<template>
  <div class="d-flex flex-wrap inline-flex pa-0 ma-0 my-auto">
    <v-row>
      <v-col cols="12">
        <span class="title-class" v-if="employed && employed.fullName">
          {{ capitalizeText(employed.fullName) }} ({{
            employed.file || "No File"
          }})
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  computed: {
    employed() {
      return this.$store.state.employees.itemsEmployed || {}; // Ensure it's an object
    },
  },
  methods: {
    capitalizeText(text) {
      if (!text) return ""; // Handle undefined or empty string
      const words = text.split(" ");
      const capitalizedWords = words.map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      });
      return capitalizedWords.join(" ");
    },
    redirectToGestionEmpleados() {
      this.$router.push({ name: "GestionEmpleados" });
    },
  },
  mounted() {
    if (
      !this.employed ||
      this.employed.name === undefined ||
      this.employed.file === undefined
    ) {
      this.redirectToGestionEmpleados();
    }
  },
};
</script>

<style scoped>
.title-class {
  color: #586271;
  font-weight: bold !important;
  font-size: large;
}
</style>
